<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Mantenedor Pólizas</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>


        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Mantenedor Pólizas</strong>
          </div>
          <b-row>
            <b-col sm="6">
              <b-button variant="primary" @click="agregar">Agregar Póliza</b-button>
              <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;">Exportar Excel</b-button>
            </b-col>
           
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column label="" min-width="100px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <!-- agregar poliza -->
  <b-modal
      title="Agregar Póliza"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalNuevo"
      @ok="agregarGuardar();"
      @cancel="modalNuevo = false"
    >
    
      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-input-group> 
              <b-form-input
                  type="text" 
                  v-model="datosFormulario.poliza"
                  @change="info_poliza">
              </b-form-input> 
              <b-input-group-prepend class="input-group-append">
                  <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
              </b-input-group-prepend>
            </b-input-group> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormulario.contratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormulario.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Vigencia Desde</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormulario.desde">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Vigencia Hasta</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormulario.hasta">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>

    <!-- Eliminar -->
    <b-modal
      title="Eliminar Póliza"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar();"
      @cancel="modalEliminar = false"
    >
        Se eliminara la siguiente póliza: 
        <br><br>
        Póliza: {{datosFormulario.poliza}}  
        <br>
        Contratante: {{datosFormulario.contratante}}
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiAtradius from "@/components/services/apiAtradius";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "MantenedorPolizasAtradius",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalEliminar : false,
      modalNuevo : false,
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      ckdDire: [
          { item:  'DL', name: 'Dirección Legal' },
          { item:  'DP', name: 'Dirección Postal' }
        ],
      ckdCorred: [
          { item: 'C', name: 'Corredor' }
        ],
      chkDireccion:false,

      data: [],
      nombreexcel: "MantenedorPolizasAtradius.xls",
      titles: [
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "asistente",
          label: "Asistente",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "desde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "hasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'120'
        }
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              if (prop === 'desde'){
                let elDate = new Date(row["desde"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'hasta'){
                let elDate = new Date(row["hasta"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      
      datosFormulario: {
          poliza:"",
          producto:"",
          contratante:"",
          desde :"",
          hasta:""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "poliza"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Eliminar";
            obj.id = 1;
            obj.name="Eliminar";
            obj.icon = "fa fa-eraser";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.eliminar(row);
            }
            botones.push(obj);
          
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.poliza = "";
      this.datosFormulario.producto="";
      this.datosFormulario.contratante ="";
      this.datosFormulario.desde ="";
      this.datosFormulario.hasta ="";
      
      return apiAtradius
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          this.datosFormularioEstado = response.data.festado;
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      
      return apiAtradius
      .recuperar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno")
        ).then( (response)=>{
            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "desde" || column.property == "hasta" 
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Mantenedor Polizas Atradius</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        //cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["desde"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["desde"])+"</td>\n";
        //cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["hasta"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["hasta"])+"</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    agregar: function(){
      this.datosFormulario.contratante = "";
      this.datosFormulario.poliza = "";
      this.datosFormulario.producto = "";
      this.datosFormulario.desde = "";
      this.datosFormulario.hasta = "";
      this.modalNuevo = true;
    },

    agregarGuardar() { 
        if (this.datosFormulario.poliza == "" || this.datosFormulario.poliza == undefined){
            this.crearNotificacion("Atención", "Debe ingresar un número de póliza.", "error");
        }else{
        return apiAtradius
          .agregar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.poliza
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha agregado con éxito.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.agregar.mensaje["descripcion"], "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      
      }
    },

    eliminar(row){
      this.datosFormulario.contratante = "";
      this.datosFormulario.poliza = "";
      this.datosFormulario.producto = "";
      this.datosFormulario.desde = "";
      this.datosFormulario.hasta = "";
      this.datosFormulario.poliza = row.poliza;
      this.datosFormulario.contratante = row.contratante;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
        return apiAtradius
          .eliminar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.poliza
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado con éxito.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
    },

    info_poliza() {
      this.$Progress.start();
      this.datosFormulario.contratante = "";
      this.datosFormulario.producto = "";
      this.datosFormulario.desde = "";
      this.datosFormulario.hasta = "";

      return apiAtradius
      .info_poliza(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.datosFormulario.poliza
        ).then( (response)=>{
            response.data = this.keysMinuscula(response.data); 
            
            var lista_data = response.data.res;
            for (var i = 0; i < lista_data.length; i++) {
              this.datosFormulario.contratante = lista_data[i]["contratante"];
              this.datosFormulario.poliza = lista_data[i]["poliza"];
              this.datosFormulario.producto = lista_data[i]["producto"];
              this.datosFormulario.desde = lista_data[i]["desde"];
              this.datosFormulario.hasta = lista_data[i]["hasta"];
            }

            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
      
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
